import {CellsContext} from '../store/panels/cells/context/cellsContext';
import {
  ConversationActionContextFinder,
  ConversationInboxIdsFinder,
  ConversationNamespaceFinder,
} from './models/conversationHelpers';

/*
 * Constants & Types.
 */

export const CellsConversationsDragType = 'CELLS_CONVERSATIONS';

export interface CellsConversationsDragItem {
  type: typeof CellsConversationsDragType;
  conversationIds: ReadonlyArray<number>;
  sourceCustomViewId: number | undefined;
  cellsContext: CellsContext;
  findConversationActionContext: ConversationActionContextFinder;
  findConversationNamespace: ConversationNamespaceFinder;
  findConversationInboxIds: ConversationInboxIdsFinder;
}
